import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getConfiguracionAplicacionPlantelService,
  updateConfiguracionAplicacionPlantelService,
} from "../../services/aplicacionConfigPlantel/aplicacionConfigPlantel.service";

export const getConfiguracionAplicacionPlantelThunk = createAsyncThunk(
  "aplicacionConfigPlantel/get",
  async (plantelId, { rejectWithValue }) => {
    try {
      return await getConfiguracionAplicacionPlantelService(plantelId);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al obtener configuración",
      );
    }
  },
);

export const updateConfiguracionAplicacionPlantelThunk = createAsyncThunk(
  "aplicacionConfigPlantel/update",
  async ({ id, frase, etiqueta_si, etiqueta_no }, { rejectWithValue }) => {
    try {
      return await updateConfiguracionAplicacionPlantelService(id, {
        frase,
        etiqueta_si,
        etiqueta_no,
      });
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al actualizar configuración",
      );
    }
  },
);
